<script setup lang="ts">
defineProps<{
  href?: string
  as?: string
  preserveState?: boolean
}>()
</script>
<template>
  <div>
    <button
      v-if="as == 'button'"
      type="submit"
      class="block w-full px-4 py-2 text-sm leading-5 text-neutral-700 dark:text-neutral-200 text-left hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-hidden focus:bg-neutral-100 dark:focus:bg-neutral-800 transition"
    >
      <slot />
    </button>

    <a
      v-else-if="as == 'a'"
      :href="href"
      class="block px-4 py-2 text-sm leading-5 text-neutral-700 dark:text-neutral-200 hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-hidden focus:bg-neutral-100 dark:focus:bg-neutral-800 transition"
    >
      <slot />
    </a>

    <inertia-link
      v-else
      :href="href"
      :preserve-state="preserveState"
      class="block px-4 py-2 text-sm leading-5 text-neutral-700 dark:text-neutral-200 hover:bg-neutral-100 dark:hover:bg-neutral-700 focus:outline-hidden focus:bg-neutral-100 dark:focus:bg-neutral-800 transition"
    >
      <slot />
    </inertia-link>
  </div>
</template>
